export const CONSTANT = {
  URL: "https://encoreevents.in/api/",
  UI_URL: "https://encoreevents.in/",
  // URL: "http://localhost:8080/api/",
  // UI_URL: "http://localhost:3000/",

  OPEN_AI_APIKEY:
    "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",

    //https://openrouter.ai/api/v1/models
};
